var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NewHeader'),_c('CapaOldMagazine',{attrs:{"revista":_vm.selecionaRevista}}),_c('IssueMagazine',{attrs:{"revista":_vm.selecionaRevista}}),_c('NewBodyImgs'),_c('NewDispositivos'),_c('NewPlanos'),_c('Maintainers'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }